import { freightHandlingUnitIdFormat } from "@redotech/redo-ids/ids";
import * as z from "zod";

export const setDefaultFreightHandlingUnit = {
  name: "setDefaultFreightHandlingUnit" as const,
  input: z.object({ id: freightHandlingUnitIdFormat.schema }),
  output: z.object({}),
};
